import React from "react";
import { Link } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";
import { kneeIcon, hipIcon, spineIcon } from "../assets/appImages";

const FALLBACK_ICONS = [kneeIcon, hipIcon, spineIcon];

const ServiceRow = ({
  number,
  title,
  description,
  icon,
  cardBg,
  border,
  accent,
  iconBg,
  arrowBg,
  badge,
  to = "/services",
}) => (
  <Link
    to={to}
    className={`group relative flex items-start gap-4 overflow-hidden rounded-[18px] border bg-gradient-to-r ${cardBg} p-5 shadow-[0_6px_24px_rgba(118,9,130,0.08)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_14px_40px_rgba(118,9,130,0.14)] md:items-center md:gap-6 md:p-6 ${border}`}
  >
    <span
      aria-hidden="true"
      className={`absolute bottom-0 left-0 top-0 w-[4px] ${accent} transition-all duration-300 group-hover:w-[6px]`}
    />

    <div
      className={`relative shrink-0 rounded-[16px] border p-2 ${iconBg} shadow-[0_4px_14px_rgba(118,9,130,0.06)]`}
    >
      <img
        src={icon}
        alt=""
        aria-hidden="true"
        className="h-[68px] w-[68px] object-contain transition-transform duration-300 group-hover:scale-105 md:h-[72px] md:w-[72px]"
      />
      <span
        className={`absolute -right-2 -top-2 flex h-6 w-6 items-center justify-center rounded-full ${badge} text-[10px] font-bold text-white shadow-sm`}
      >
        {number}
      </span>
    </div>

    <div className="min-w-0 flex-1 pt-1 md:pt-0">
      <h3 className="text-[18px] font-bold text-brand-purple md:text-[20px]">{title}</h3>
      <div
        className="mt-2 text-[13px] leading-[1.75] text-[#5A5A5A] md:text-[14px] [&_p]:m-0"
        dangerouslySetInnerHTML={{ __html: description || "" }}
      />
    </div>

    <span
      className={`mt-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border transition-all duration-300 group-hover:scale-110 md:mt-0 ${arrowBg}`}
    >
      <FaChevronRight className="text-[11px]" aria-hidden="true" />
    </span>
  </Link>
);

const Services = ({ services }) => {
  const items = Array.isArray(services) ? services : [];

  if (items.length === 0) return null;

  return (
    <section className="relative overflow-hidden py-12 md:py-16 lg:py-20">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute right-0 top-1/2 h-[500px] w-[500px] -translate-y-1/2 translate-x-1/3 rounded-full bg-brand-purple/[0.06] blur-3xl"
      />

      <div className="relative mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid items-start gap-10 lg:grid-cols-[minmax(0,42%)_minmax(0,58%)] lg:gap-14 xl:gap-20">
          <div className="text-left lg:sticky lg:top-16">
            <p className="text-[18px] font-bold text-brand-orange">Our Services</p>
            <h2 className="mt-4 max-w-md text-3xl font-bold leading-[1.45] text-brand-purple md:mt-5 md:text-4xl md:leading-[1.4] lg:text-[2.5rem] lg:leading-[1.35]">
              Expert Orthopaedics &amp; Spine Treatments
            </h2>
            <p className="mt-6 text-[14px] leading-[1.75] text-[#555555] md:mt-7 md:text-[15px]">
              From diagnosis to recovery, we deliver personalized surgical care that helps you move
              with confidence again.
            </p>

            <Link
              to="/services"
              className="mt-8 inline-block rounded-lg bg-brand-orange px-7 py-3 text-[15px] font-medium text-white shadow-cta-orange transition-opacity hover:opacity-90"
            >
              All Services
            </Link>
          </div>

          <div className="rounded-[24px] border border-[#E2DAEC] bg-white/80 p-4 shadow-[0_10px_40px_rgba(118,9,130,0.07)] backdrop-blur-sm md:p-5">
            <div className="flex flex-col gap-4 md:gap-5">
              {items?.map((item, index) => (
                <ServiceRow
                  key={item.id}
                  {...item}
                  icon={item.icon || FALLBACK_ICONS[index % FALLBACK_ICONS.length]}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
